import a_history from './img/a_history.jpg'
import a_people_history from './img/a_people_history.jpg'
import america_and_britain from './img/america_and_britain.jpg'
import band_of_brothers from './img/band_of_brothers.jpg'
import endurance from './img/endurance.jpg'
import genghis_khan from './img/genghis_khan.jpg'
import guns_germs_steel from './img/guns_germs_steel.jpg'
import over_the_edge from './img/over_the_edge.jpg'
import say_nothing from './img/say_nothing.jpg'
import spqr from './img/spqr.jpg'
import the_americans from './img/the_americans.jpg'
import the_argumentative from './img/the_argumentative.jpg'
import the_battle_for_spain from './img/the_battle_for_spain.jpg'
import the_crusades from './img/the_crusades.jpg'
import the_devil_in_the from './img/the_devil_in_the.jpg'
import the_diary from './img/the_diary.jpg'
import the_discovery from './img/the_discovery.jpg'
import the_guns_of_august from './img/the_guns_of_august.jpg'
import the_rise_and_fall from './img/the_rise_and_fall.jpg'
import the_story_of from './img/the_story_of.jpg'


export const HIBookItems = [
  {
    id:1101,
    title:"A History of the American People",
    image: a_history,
    price:1559,
    
  },
  {
    id:1102,
    title:"A People's history of the United States",
    image: a_people_history,
    price:699,
    
  },
  {
    id:1103,
    title:"1776 America and Britain at War",
    image: america_and_britain,
    price:499,
    
  },
  {
    id:1104,
    title:"Band Of Brothers",
    image: band_of_brothers,
    price:1899,
    
  },
  {
    id:1105,
    title:"Endurance",
    image: endurance,
    price:1399,
    
  },
  {
    id:1106,
    title:"Genghis Khan and the Making of the Modern World",
    image: genghis_khan,
    price:599,
    
  },
  {
    id:1107,
    title:"Guns Germs & Steel",
    image: guns_germs_steel,
    price:3999,
    
  },
  {
    id:1108,
    title:"Over the Edge of the World",
    image: over_the_edge,
    price:7399,
    
  },
  {
    id:1109,
    title:"Say Nothing",
    image: say_nothing,
    price:399,
    
  },
  {
    id:1110,
    title:"SPQR",
    image: spqr,
    price:1499,
    
  },
  {
    id:1111,
    title:"1491 The Americas before Columbus",
    image: the_americans,
    price:1319,
    
  },
  {
    id:1112,
    title:"The Argumentative Indian",
    image: the_argumentative,
    price:399,
    
  },
  {
    id:1113,
    price:899,
    title: "The Battle For Spain",
    image: the_battle_for_spain,
    
  },
  {
    id:1114,
    price:1999,
    title: "The Crusades",
    image: the_crusades,
   
  },
  {id:1115,
    price:1999,
    title: "The Devil In The White City",
    image: the_devil_in_the,
    
  },
  {
    id:1116,
    price:99,
    title: "The Diary of a Young Girl",
    image: the_diary,
    
  },
  {
    id:1117,
    price:499,
    title: "Jawaharlal Nehru The Discovery of India",
    image: the_discovery,
    
  },
  {
    id:1118,
    price:669,
    title: "The Guns Of August",
    image: the_guns_of_august,
    
  },
  {
    id:1119,
    price:1799,
    title: "The Rise and Fall of the Third Reich",
    image: the_rise_and_fall,
    
  },
  {
    id:1120,
    price:7339,
    title: "The Story of Civilization",
    image: the_story_of,
    
  },  
];